<template>
  <div class="certification_details">
    <div class="tit">
      <span>
        <router-link
          to="/personal_center/enterprise/staff_management/staff_manegement_record"
          class="back"
        >
          <i class="el-icon-arrow-left"></i>
        </router-link>员工管理详情
      </span>
    </div>
    <div class="body_content">
      <!-- 员工详情列表 -->
      <el-row v-if="authentication_list">
        <el-col :span="24">
          <div class="detail_l">姓名：</div>
          <div class="detail_r" v-if="authentication_list.name">{{ authentication_list.name }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">性别：</div>
          <div class="detail_r" v-if="authentication_list.sex_name">{{ authentication_list.sex_name }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">联系方式：</div>
          <div class="detail_r" v-if="authentication_list.mobile">{{ authentication_list.mobile }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">身份证号：</div>
          <div class="detail_r" v-if="authentication_list.id_num">{{ authentication_list.id_num }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">所属公司：</div>
          <div class="detail_r" v-if="authentication_list.enterprise_name">{{ authentication_list.enterprise_name }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">认证园区：</div>
          <div class="detail_r" v-if="authentication_list.incubator_name">{{ authentication_list.incubator_name }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">所属部门：</div>
          <div class="detail_r" v-if="authentication_list.department">{{ authentication_list.department }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">职位：</div>
          <div class="detail_r" v-if="authentication_list.position">{{ authentication_list.position }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">工号：</div>
          <div class="detail_r" v-if="authentication_list.job_num">{{ authentication_list.job_num }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">认证申请说明：</div>
          <div class="detail_r" v-if="authentication_list.explain">{{ authentication_list.explain }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">提交时间：</div>
          <div class="detail_r" v-if="authentication_list.create_date">{{ authentication_list.create_date }}</div>
          <div v-else>暂无</div>
        </el-col>
        <div v-if="authentication_list.status_code !== 'IdentityCertifieStatusSubmitted'">
          <el-col :span="24">
            <div class="detail_l">审核备注说明：</div>
            <div class="detail_r" v-if="authentication_list.examine_remark">{{ authentication_list.examine_remark }}</div>
            <div v-else>暂无</div>
          </el-col>
        </div>
        <div v-if="authentication_list.status_code === 'IdentityCertifieStatusSubmitted'">
          <el-col :span="24">
            <div class="detail_l">审核备注说明：</div>
            <el-input type="textarea" v-model="examine_remark"></el-input>
          </el-col>
        </div>
      </el-row>
    </div>
    <!-- 已提交状态下显示 -->
    <div v-if="authentication_list.status_code == 'IdentityCertifieStatusSubmitted'" class="btn">
        <button class="foot" @click="passCertificate">通过</button>
        <button class="foot" @click="nopassCertificate">不通过</button>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            authentication_list:{}, //认证详情
            examine_remark:'' //审核备注说明
        }
    },
    created(){
        // 获取员工详情
        this.getAuthenticateEmployees()
    },
    methods:{
      // 获取员工详情
        getAuthenticateEmployees(){
            this.api.getAuthenticateEmployees({
                id:this.$route.query.id
            })
            .then(res => {
                console.log(res)
                if(res.error.err_code != 0) return;
                this.authentication_list = res.obj.list[0]
            })
        },
        // 通过认证
        passCertificate(){
            this.$confirm(`您确定同意员工${this.authentication_list.name}的员工认证吗？`, '提示', {
                confirmButtonText: '同意',
                cancelButtonText: '取消',
                type: 'warning'
            })
            .then(() => {
                console.log(this.authentication_list.id)
                this.api.authenticateEmployeeApproval({
                    id:this.authentication_list.id,
                    operation:'IdentityCertifieStatussuccess',
                    examine_remark: this.examine_remark
                })
                .then(res => {
                    console.log(res)
                    if(res.error.err_code != 0) return;
                    this.$message({
                        type: 'success',
                        message: '您已同意！'
                    });
                    // 重新获取详情
                    this.getAuthenticateEmployees()
                })

            })
            .catch(() => {
                return
            });
        },
        // 不通过认证
        nopassCertificate(){
            this.$confirm(`您确定拒绝员工${this.authentication_list.name}的员工认证吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
            .then(() => {
                this.api.authenticateEmployeeApproval({
                    id:this.authentication_list.id,
                    operation:'IdentityCertifieStatusFailed',
                    examine_remark:this.examine_remark
                })
                .then(res => {
                    console.log(res)
                    if(res.error.err_code != 0) return;
                    this.$message({
                        type: 'success',
                        message: '您已拒绝！'
                    });
                    // 重新获取详情
                    this.getAuthenticateEmployees()
                })

            })
            .catch(() => {
                return
            });

        },
    }

}
</script>

<style lang="scss" scoped>
.certification_details {
    line-height: 41px;
  .tit {
    .back {
      display: inline-block;
      width: 38px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      border: 1px solid #dcdfe6;
      margin-right: 14px;
      cursor: pointer;
      vertical-align:middle;;
    }
  }
  .el-col{
    display: flex;
    font-size: 14px;
  }
  .detail_l {
    color: #999;
  }
  .detail_r {
    flex:1;
  }
  .btn{
      margin-left: 138px;
      margin-bottom: 20px;
      .foot{
          border: 1px solid #333;
          background-color: #333;
          color: #ffffff;
          margin-right: 15px;
          width: 70px;
          height: 35px;
      }
  }
}
</style>
